// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1zloq","loaderOuter":"PageOverlayLoader_loaderOuter__1rwL4"};